export enum TimerIndex {
    ignore = 0,
    disable = 1,
    week1 = 2,
    week4 = 3,
    week13 = 4,
    Week52 = 5,
    week104 = 6,
    week156 = 7
}

export const TimerIndexDescriptions: { [key in TimerIndex]: string } = {
    [TimerIndex.ignore]: 'Ignore',
    [TimerIndex.disable]: 'Disable',
    [TimerIndex.week1]: '1 Week',
    [TimerIndex.week4]: '4 Weeks',
    [TimerIndex.week13]: '13 Weeks',
    [TimerIndex.Week52]: '52 Weeks',
    [TimerIndex.week104]: '104 Weeks',
    [TimerIndex.week156]: '156 Weeks'
}